<template>
    <el-row :gutter="30"  class="mw-100 manage-fact" >
        
        <el-col :lg="24" :xs="24">
            
            <el-card>
                <el-form
                    class="text-center font-24" 
                    ref="addParentFactRef"
                    :model="currentFactData"
                    :rules="currentFactDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageFact('addFactRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        
                        <el-col :lg="12" :xs="24">
                            <el-form-item  label="fact image" prop="imageBase64">
                                <el-image 
                                    style="width: 250px; height: 250px;margin-right:20px" 
                                    :src="isAddFact ? currentFactData.imageURL :  $getImage(currentFactData.imageURL) || ''" 
                                    fit="cover"
                                    :zoom-rate="1.2"
                                    :preview-src-list="[isAddFact ? currentFactData.imageURL : $getImage(currentFactData.imageURL)]"
                                    :preview-teleported="true"
                                >
                                    <template #error>
                                        <div class="image-slot">
                                            <font-awesome-icon :icon="['fas', 'image']" />
                                        </div>
                                    </template>
                                </el-image>
                                <el-upload
                                    ref="imageBase64"
                                    action="#"
                                    :auto-upload="false"
                                    :on-change="onUploadImage"
                                    :disabled="fileUploaded"
                                    :on-remove="handleRemoveImage"
                                    accept="image/png, image/jpeg,image/gif"
                                    class="font-24 d-flex align-center flex-1"
                                >
                                    <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        
                        
                    </el-row>
                </el-form>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentFactData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addFactRef"
                            :model="currentFactData"
                            :rules="currentFactDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                               
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentFactData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentFactData.translates[index].description"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="value" :prop="`value`" >
                                        <el-input type="text" v-model="currentFactData.value"></el-input>    
                                    </el-form-item>
                                </el-col>
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
            isAddFact:true,
            currentFact:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentFactData:{},
            currentFactDataRules:{
                value:{
                    required:true,
                    message:'required field',
                    trigger:'blur',
                },
                translates:this.$setTranslateRules(['title','description']),
            }
        };
    },
    computed:{
        cachedFact(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.home?.facts.currentFact || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedFact.id) {
            this.isAddFact = false;
            this.currentFactData = JSON.parse(JSON.stringify(this.cachedFact))
            this.currentFactData.translates = this.$filterPublishedTranslates(this.currentFactData.translates)
        }else{
            this.$router.push({
                name:'facts-list',
            })
            this.currentFactDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
            this.isAddFact = true;
            this.currentFactData = this.initState()
        }
    },
    
    methods:{
        initState(){
            return {
                
                translates:this.$setTranslateKeys({
                    'title':'',
                    'description':'',
                })
            }
        },
       
        async manageFact(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addFactRef'].length){
                            this.manageFactAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async manageFactAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddFact ? 'addFact':'updateFact',this.currentFactData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllFacts');
                this.$router.push({
                    name:'facts-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentFactData.imageBase64 = evt.target.result;
                }); 
                this.currentFactData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        },    
        handleRemoveImage(){
            this.currentFactData.imageURL = this.isAddFact ? '' : this.cachedFact.imageURL
        }, 
    }
}
</script>
<style lang="scss">
    .manage-fact {
        .ck-editor {
            width:100%;
        }
    }
</style>